module.exports = __webpack_public_path__ + "static/Netherlands-2a3728c7a8c5abd7cb6ef0c5340cdb6f.png";